var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6960",
    "data-name": "Group 6960",
    transform: "translate(-245.191 -0.572)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1222",
    "data-name": "Ellipse 1222",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(245.191 0.572)",
    fill: "#132320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15274",
    "data-name": "Path 15274",
    d: "M-6.093-30.04A3.551,3.551,0,0,1-3.449-29a3.337,3.337,0,0,1,1.024,2.415,3.077,3.077,0,0,1-.237,1.215,2.6,2.6,0,0,1-.573.879,4.6,4.6,0,0,1-.68.543,3.568,3.568,0,0,1-.573.313l-.245.076a2.59,2.59,0,0,1-.023.4.735.735,0,0,1-.138.3.646.646,0,0,1-.382.229,2.955,2.955,0,0,1-.711.069,2.672,2.672,0,0,1-.711-.076.6.6,0,0,1-.375-.26.973.973,0,0,1-.13-.329,3.185,3.185,0,0,1-.023-.451.322.322,0,0,1,.008-.054.354.354,0,0,0,.008-.069,1.421,1.421,0,0,1,.375-1.04,1.824,1.824,0,0,1,.818-.5A2.339,2.339,0,0,0-5.2-25.76a.921.921,0,0,0,.375-.764,1.059,1.059,0,0,0-.283-.795,1.4,1.4,0,0,0-.986-.275,1.246,1.246,0,0,0-.7.176.759.759,0,0,0-.329.359l-.046.183a1.792,1.792,0,0,1-.321.6.659.659,0,0,1-.52.206,1.817,1.817,0,0,1-.611-.138,2.562,2.562,0,0,1-.8-.443.648.648,0,0,1-.222-.474,2.3,2.3,0,0,1,.122-.535l.031-.076q.031-.092.092-.252a3.444,3.444,0,0,1,.329-.558,3.5,3.5,0,0,1,.611-.7,3.459,3.459,0,0,1,.971-.55A3.7,3.7,0,0,1-6.093-30.04Zm.076,8.637a1.606,1.606,0,0,1,1.147.321A1.653,1.653,0,0,1-4.6-19.951a3.66,3.66,0,0,1-.031.543,1.455,1.455,0,0,1-.153.428.7.7,0,0,1-.436.336,2.772,2.772,0,0,1-.818.1,1.7,1.7,0,0,1-1.162-.321,1.229,1.229,0,0,1-.26-.887V-20a4.651,4.651,0,0,1,.023-.535,1.292,1.292,0,0,1,.145-.42A.724.724,0,0,1-6.85-21.3,2.647,2.647,0,0,1-6.017-21.4Z",
    transform: "translate(261.37 35.011)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkRounded);
export default __webpack_public_path__ + "static/media/question-mark-rounded.3a009a4d.svg";
export { ForwardRef as ReactComponent };